export default function Terms() {
  return (
    <div className="pb-20 pt-4">
      <div className="container mx-auto px-4 max-w-2xl">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Terms of Service
        </h2>

        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 border border-gray-200 dark:border-gray-700 space-y-4">
          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              1. Acceptance of Terms
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              By accessing and using BaseVibe, you accept and agree to be bound by these Terms of Service.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              2. Description of Service
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              BaseVibe is a decentralized application that allows users to vote on daily crypto market sentiment. 
              The service is provided "as is" without warranties of any kind.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              3. User Responsibilities
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Users are responsible for:
            </p>
            <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
              <li>Maintaining the security of their wallet and private keys</li>
              <li>All transactions made through their wallet</li>
              <li>Understanding the risks of blockchain transactions</li>
              <li>Complying with all applicable laws and regulations</li>
            </ul>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              4. Blockchain Transactions
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              All votes are recorded on the Base blockchain. Transactions are irreversible and may incur gas fees. 
              BaseVibe is not responsible for failed transactions or gas costs.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              5. No Investment Advice
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              BaseVibe displays community sentiment only. This is not financial advice. 
              Do not make investment decisions based solely on sentiment data.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              6. Limitation of Liability
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              BaseVibe and its creators shall not be liable for any damages arising from use of the service, 
              including but not limited to loss of funds, data, or access.
            </p>
          </section>

          <section>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
              7. Changes to Terms
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              We reserve the right to modify these terms at any time. Continued use constitutes acceptance of updated terms.
            </p>
          </section>

          <div className="text-xs text-gray-500 dark:text-gray-400 pt-4 border-t border-gray-200 dark:border-gray-700">
            Last updated: November 6, 2025
          </div>
        </div>
      </div>
    </div>
  )
}

